import './ActionMenu-bb42318d.css';

var styles = {"ActionMenuContainer":"prc-ActionMenu-ActionMenuContainer-XdFHv"};

export { styles as default };
